import {
  Home,
  User,
  ShieldCheck,
  Calendar,
  IndianRupee,
  FileCheck,
  HelpCircle,
  Package,
  LifeBuoy,
  BookOpen,
  MapPin,
} from 'lucide-react';

/**
 * Single Source of Truth for Employee My Portal navigation options.
 * Used by both Sidebar.js and ESSPortal.js (Quick Actions).
 */
export const ESS_NAVIGATION = [
  {
    label: 'Overview',
    path: '/ess/portal',
    icon: Home,
    isOverview: true,
  },
  {
    label: 'My Profile',
    path: '/employee-profile',
    icon: User,
    desc: 'View and manage personal details & profile information',
    color: 'bg-indigo-50 text-indigo-600',
    testId: 'qa-my-profile',
  },
   {
    label: 'Leave & Attendance',
    path: '/ess/leave-attendance',
    icon: Calendar,
    desc: 'Apply leave, check balances & submit attendance regularization',
    color: 'bg-blue-50 text-blue-600',
    testId: 'qa-leave-attendance',
  },
    {
    label: 'Local Conveyance',
    path: '/ess/local-travel',
    icon: MapPin,
    desc: 'Record daily on-duty local travel, site visits & conveyance',
    color: 'bg-orange-50 text-orange-600',
    testId: 'qa-local-travel',
  },
  {
    label: 'Statutory Forms',
    path: '/ess/statutory-forms',
    icon: ShieldCheck,
    desc: 'Employee details, Form 12BB & statutory compliance declarations',
    color: 'bg-emerald-50 text-emerald-600',
    testId: 'qa-statutory-forms',
  },
  {
    label: 'Pay & Tax',
    path: '/ess/pay-tax',
    icon: IndianRupee,
    desc: 'View and download payslips, tax projections & salary details',
    color: 'bg-purple-50 text-purple-600',
    testId: 'qa-pay-tax',
  },
  {
    label: 'My Official Letters',
    path: '/ess/appointment-order',
    icon: FileCheck,
    desc: 'View and download your official employment letters',
    color: 'bg-cyan-50 text-cyan-600',
    testId: 'qa-appointment-order',
  },
  {
    label: 'KYC Confirmation',
    path: '/ess/kyc',
    icon: ShieldCheck,
    desc: 'Review and confirm personal & statutory KYC verification details',
    color: 'bg-amber-50 text-amber-600',
    testId: 'qa-kyc',
  },
  {
    label: 'My Assets & Docs',
    path: '/ess/assets-docs',
    icon: Package,
    desc: 'View assigned company assets and asset documentation',
    color: 'bg-teal-50 text-teal-600',
    testId: 'qa-assets-docs',
  },
  {
    label: 'Help Desk',
    path: '/ess/helpdesk',
    icon: LifeBuoy,
    desc: 'Raise support tickets & track query resolution status',
    color: 'bg-rose-50 text-rose-600',
    testId: 'qa-helpdesk',
  },
   {
    label: 'Conveyance Ledger',
    path: '/ess/conveyance-ledger',
    icon: BookOpen,
    desc: 'View personal local & travel conveyance ledger, expenses & approval history',
    color: 'bg-emerald-50 text-emerald-600',
    testId: 'qa-conveyance-ledger',
  },
  {
    label: 'User Guide',
    path: '/ess/user-guide',
    icon: BookOpen,
    desc: 'Employee portal user manual & operating instructions',
    color: 'bg-sky-50 text-sky-600',
    testId: 'qa-user-guide',
  },
 
];

